var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReopen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29022",
    "data-name": "Group 29022",
    transform: "translate(1309 -270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29019",
    "data-name": "Group 29019"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1537",
    "data-name": "Ellipse 1537",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(-1309 270)",
    fill: "rgba(0,142,255,0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29021",
    "data-name": "Group 29021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29020",
    "data-name": "Group 29020",
    transform: "translate(-1329.367 -33.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M13.34,5.612a5.418,5.418,0,0,1,10.215,0H28.38a4.519,4.519,0,0,1,4.515,4.515V33.6a4.516,4.516,0,0,1-4.515,4.515H8.515A4.514,4.514,0,0,1,4,33.6V10.126A4.513,4.513,0,0,1,8.515,5.612Z",
    transform: "translate(33.92 315.08)",
    fill: "#008eff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36116",
    "data-name": "Path 36116",
    d: "M18.411,8.8a.8.8,0,0,0-.8.8,8.031,8.031,0,1,1-2.321-5.616.69.69,0,0,1-.08.017h-2.4a.8.8,0,1,0,0,1.6h2.4a2.4,2.4,0,0,0,2.4-2.4V.8a.8.8,0,0,0-1.6,0V2.452a9.593,9.593,0,1,0,3.2,7.147A.8.8,0,0,0,18.411,8.8Z",
    transform: "translate(42.757 328.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36117",
    "data-name": "Path 36117",
    d: "M11.8,6a.8.8,0,0,0-.8.8v4a.8.8,0,0,0,.234.565l2.4,2.4a.8.8,0,1,0,1.132-1.131L12.6,10.468V6.8a.8.8,0,0,0-.8-.8Z",
    transform: "translate(40.563 327.538)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopen);
export default __webpack_public_path__ + "static/media/reopen.c2ae34ab6dbd408bda3f0f03f04bb307.svg";
export { ForwardRef as ReactComponent };